// extracted by css-extract-rspack-plugin
export default {"banner":"CoreSsoBanner-module__banner__UeBwA"};